import { motion } from "framer-motion";
import { Palette, Smartphone, Layout, Code } from "lucide-react";
import { Link } from "react-router-dom";

const services = [
  {
    icon: Palette,
    title: "Graphic Design",
    description: "Creating visual content that communicates messages effectively",
    color: "bg-purple-100",
    link: "/logo-designs"
  },
  {
    icon: Layout,
    title: "UI/UX Design",
    description: "Crafting intuitive and engaging user experiences",
    color: "bg-accent-navy/10",
    link: "/ux-designs"
  },
  {
    icon: Smartphone,
    title: "Mobile App Development",
    description: "Building native and cross-platform mobile applications",
    color: "bg-green-100",
    link: "/mobile-app-designs"
  },
  {
    icon: Code,
    title: "Website Development",
    description: "Developing responsive and modern websites",
    color: "bg-orange-100",
    link: "/web-development"
  }
];

export const Services = () => {
  return (
    <>
      <section className="py-20 px-4" id="services">
        <div className="max-w-7xl mx-auto">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-center mb-16 text-white"
          >
            Our Services
          </motion.h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <motion.div
                key={service.title}
                initial={{ opacity: 1, y: 20 }}
                whileInView={{ opacity:1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                whileHover={{ scale: 1.05 }}
                className="p-6 rounded-lg bg-accent-navy border border-gray-800 flex flex-col h-full"
              >
                <service.icon className="w-12 h-12 text-coral mb-4" />
                <h3 className="text-lg font-semibold mb-2 text-white">{service.title}</h3>
                <p className="text-gray-100 mb-4 text-sm opacity-50">{service.description}</p>
                
                <Link to={service.link} className="text-coral hover:underline mt-auto">
                  See our work →
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};